import { OktaAuth } from "@okta/okta-auth-js";

import { oktaConfig } from "./okta-config";

// From okta-react sdk v4 onwards, you now must have the okta-auth-js as a dependency, with
// oktaAuth instantiated here and imported then passed to the <Security /> component which
// provides to all child components.
export const oktaAuth = new OktaAuth(oktaConfig.oidc);
